/**
 * Generated by "@vuepress/internal-layout-components"
 */
export default {
  "NotFound": () => import("/dpan/ezhushou/data/vuepress/node_modules/@vuepress/theme-default/layouts/404.vue"),
  "Layout": () => import("/dpan/ezhushou/data/vuepress/node_modules/@vuepress/theme-default/layouts/Layout.vue") 
}